import { useLingui } from '@lingui/react/macro';
import { styled } from '@linaria/react';
import { VisibilityHidden } from 'app-ui/primitives/accessibility';
import { Loader } from 'app-ui/primitives/feedback';
import { themeCssVariables } from 'app-ui/theme';

import { LOADING_STATE_DELAY_IN_MILLISECONDS } from '@/ui/feedback/loading-state/constants/LoadingStateDelayInMilliseconds';

// Fills whatever holds it, like EmptyState.
const StyledContainer = styled.div`
  align-items: center;
  animation: loading-state-fade-in
    calc(${themeCssVariables.animation.duration.fast} * 1s) ease-out
    ${LOADING_STATE_DELAY_IN_MILLISECONDS}ms both;
  box-sizing: border-box;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: ${themeCssVariables.spacing[8]};

  @keyframes loading-state-fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const LoadingState = () => {
  const { t } = useLingui();

  return (
    <StyledContainer role="status">
      <Loader />
      <VisibilityHidden>{t`Loading`}</VisibilityHidden>
    </StyledContainer>
  );
};
